// extracted by mini-css-extract-plugin
module.exports = {"fishGroup":"FishGroup_fishGroup__5JqC5"};